import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL

const postEdital = async (
    token: string,
    titulo: string,
    descricao: string,
    link_pdf: string,
    data_lancamento: string,
    data_encerramento: string
) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    }
  };
  const response = await axios.put(`${API_URL}/editais`, {
    titulo,
    descricao,
    link_pdf,
    data_lancamento,
    data_encerramento
  }, config);
  return response.data;
};
export default postEdital;
